export const environment = {
	production: false,
	DO_URL: 'https://lmc.lol/api',
	version: '6.30.0',
	environment: 'Staging',
	iframeURL: 'https://lmc.lol',
	rapidURL: 'https://lmcrapiddemo.ca/api',
	accountsEmail: 'testing@lmcredit.com',
};
